import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import FilterName from '@/features/filter/v2/FilterName';
import Checkbox from '@/features/filter/v2/Checkbox';
import { allFilterPages } from '@/features/filter/static/filterUtil';

const Owner = ({ filterPageName, isDependentFilter }) => {
	const [options, setOptions] = useState([]);
	const [allOptionList, setAllOptionList] = useState([]);
	const storeData = []; //TODO ( fetch store data for corresponding field)
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);

	useEffect(() => {
		if (!isDependentFilter) {
			setOptions(allOptionList);
		}
	}, [storeData]);

	useEffect(() => {
		onSetFieldData();
	}, [dependentFilterList]);

	const filterData = {
		[allFilterPages.PROJECT_DETAILS]: dependentFilterList?.ownerList,
		[allFilterPages.MY_PROJECTS]: dependentFilterList?.ownerIdList
	};

	const onSetFieldData = () => {
		let responseData = filterData[filterPageName]?.map((item) => ({
			...item,
			id: item?.id,
			name: item?.name
		}));

		setAllOptionList(responseData);
		setOptions(responseData);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allOptionList.filter((item) => item.name.toLowerCase().includes(e.target.value.toLowerCase()))
			: allOptionList;
		setOptions(searchResult);
	};

	return (
		<>
			<FilterName type="OWNER" />
			<Checkbox type="OWNER" data={options} handleSearch={handleSearch} />
		</>
	);
};

export default Owner;
